import React, { useState } from 'react';
import { BackgroundEffects } from './components/BackgroundEffects';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { About } from './components/About';
import { Services } from './components/Services';
import { Benefits } from './components/Benefits';
import { Process } from './components/Process';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { LegalModal } from './components/LegalModal';
export function App() {
  const [legalModal, setLegalModal] = useState<'privacy' | 'terms' | null>(null);
  return <div className="relative min-h-screen bg-mystic-black text-mystic-white font-sans selection:bg-mystic-gold/30 selection:text-mystic-white" data-id="element-0">
      <BackgroundEffects data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Problems data-id="element-4" />
        <About data-id="element-5" />
        <Services data-id="element-6" />
        <Benefits data-id="element-7" />
        <Process data-id="element-8" />
        <Testimonials data-id="element-9" />
        <FAQ data-id="element-10" />
        <FinalCTA data-id="element-11" />
      </main>

      <Footer onOpenPrivacy={() => setLegalModal('privacy')} onOpenTerms={() => setLegalModal('terms')} data-id="element-12" />
      <FloatingWhatsApp data-id="element-13" />

      <LegalModal isOpen={legalModal !== null} onClose={() => setLegalModal(null)} type={legalModal} data-id="element-14" />
    </div>;
}